module.exports = __webpack_public_path__ + "media/newstyle/images/stars_4-orange-d7c1d17b66011f9718cd68942eaf5536.svg";